<template>
  <div class="app-admin-nav">
    <b-nav class="navbar navbar-expand-lg navbar-dark bg-lighter fixed-top" id="mainNav">
      <a class="navbar-brand" href="#"></a>
      <b-navbar-toggle aria-controls="navbarResponsive"
                       aria-expanded="false"
                       aria-label="Toggle navigation"
                       target="nav_collapse"
                       class="navbar-toggler navbar-toggler-right"
                       :class="{ open: isOpen }"
                       type="button">
        <span>
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </span>
      </b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <ul id="dynamicNav" class="navbar-nav navbar-sidenav side-shadow">
          <li v-for="(navItem, i) in navItems" :key="i" class="nav-item" :class="{ active: i === 0 }">
            <a class="nav-link"
               @click.prevent="scrollToSection(navItem.sectionId)"
               :href="navItem.sectionId"
               :data-cy="navItem.section + '-menu'">
              <span class="nav-link-text d-block">
                {{ navItem.pageTitle }}
                <small class="d-block"></small>
              </span>
            </a>
          </li>
          <li class="nav-item nav-item-pdf">
            <a class="nav-link" @click="generatePDF"><span class="nav-link-text d-block">PDF <i class="fa fa-file-pdf-o"></i></span></a>
          </li>
        </ul>
      </b-collapse>
    </b-nav>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import scrollTo from '../../utils/mixins/ScrollToMixin'
import debounce from 'lodash.debounce'

export default {
  name: 'Navigation',
  mixins: [scrollTo],
  components: {},
  data () {
    return {
      isOpen: false,
      firstNavItem: {},
      section: {},
      sections: {},
      scrollPosition: null,
      i: 0,
    }
  },
  computed: {
    ...mapState({
      navItems (state) {
        let flag = ''
        const array = []
        state.report.pages.forEach((page) => {
          if (flag === page.section) {
            return
          }
          if (page.section === 'report-sales') {
            page.pageTitle = 'Recently Sold'
          }
          if (page.section === 'market') {
            page.pageTitle = 'On The Market'
          }
          array.push(page)
          flag = page.section
        })
        return array
      },
    }),
  },
  watch: {
    navItems () {
      this.setNavigationState()
    },
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      this.isOpen = isJustShown
    })
  },
  methods: {
    ...mapMutations({
      updateSections: 'report/updateSections',
    }),
    setNavigationState () {
      this.section = document.querySelectorAll('.section')
      this.sections = {}
      for (let i = 0; i < this.section.length; i++) {
        this.sections[this.section[i].id] = this.section[i].offsetTop - 71
      }

      this.updateSections(this.sections)

      window.onscroll = () => {
        debounce(this.setActiveState, 500)()
      }
    },
    setActiveState () {
      this.scrollPosition = document.documentElement.scrollTop || document.body.scrollTop

      for (this.i in this.sections) {
        if (this.sections[this.i] <= this.scrollPosition) {
          if (document.querySelector('.active')) {
            document.querySelector('.active').classList.remove('active')
          }
          document.querySelector('a[href*=' + this.i + ']').parentElement.classList.add('active')
        }
      }
    },
    generatePDF () {
      let rawHTML = document.documentElement.innerHTML
      const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi
      while (SCRIPT_REGEX.test(rawHTML)) {
        rawHTML = rawHTML.replace(SCRIPT_REGEX, '')
      }
      const headerCopy = rawHTML.replace(/^.*?<head[^>]*>(.*?)<\/head>.*$/is, '$1')
      const bodyCopy = rawHTML.replace(/^.*?<body[^>]*>(.*?)<\/body>.*$/is, '$1')
      this.$reportHS.$pdf.generatePDFTemplate({ header: headerCopy, body: bodyCopy })
    },
  },
  beforeDestroy () {
    this.$root.$off('bv::collapse::state')
  },
}
</script>

<style lang="scss" scoped>
  body.fixed-nav {
    padding-top: 54px;
    @media (min-width: 992px) {
      padding-top: 56px;
    }
  }

  #mainNav.fixed-top {
    @media (min-width: 992px) {
      .navbar-sidenav {
        height: 100vh;
        padding-top: 0rem;
      }
    }
  }

  @media (min-width: 992px) {
    .content-wrapper {
      margin-left: $sidenav-base-width;
    }
  }

  .navbar-sidenav-tooltip.show {
    display: none;
  }
  /*Global End*/

  /*Navbar START*/
  #mainNav {
    font-family: "averta", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    font-size: 1rem;
    font-stretch: 100%;
    font-weight: 400;
    &.bg-darker {
      background-color: $nav-bg-colour;
    }
    &.bg-lighter {
      background-color: $nav-bg-white-colour;
      box-shadow: 0px 0px 40px -5px rgba(0,0,0,.2);
    }

    .side-shadow {
      box-shadow: 0px 0px 40px -5px rgba(0,0,0,.2);
    }

    .navbar-collapse {
      overflow: auto;
      max-height: 75vh;

      .navbar-nav {

        .nav-item {
          .nav-link {
            cursor: pointer;

            &.not-clickable {
              pointer-events: none;
            }
          }

          .nav-link-text {
            color: $nav-item-colour;
            clear: both;
            font-size: $nav-item-font-size;
          }
          &.nav-item-pdf {
            /* Waiting for BE */
            display: none;
          }
        }
      }
    }

    .navbar-brand {
      width: 255px;
      height: 55px;
      background-size: $nav-logo-size;
      top: $nav-logo-top-offset;
      position: relative;
      background-image: url(../../assets/themes/master/homesearch-black.svg);
      background-repeat: $nav-logo-repeat;
    }

    @media (min-width: 992px) {

      .navbar-collapse {
        overflow: visible;
        max-height: none;

        .navbar-sidenav {
          position: absolute;
          top: 0;
          left: 0;
          overflow-x: hidden;
          overflow-y: auto;
          -webkit-flex-direction: column;
          -ms-flex-direction: column;
          flex-direction: column;
          margin-top: $sidenav-offset-top;
          background-blend-mode: exclusion;
          background-position: bottom;

          > .nav-item {
            width: $sidenav-base-width;
            padding: 0;
            position: relative;

            &:hover, &.active {
              border-left: 6px solid $sidenav-bg-colour-hover;
            }

            > .nav-link {
              color: $nav-item-colour;
              display: block;
              padding: .7rem 1rem;
            }

            &.active {

              > .nav-link {
                &:focus {
                  text-decoration: none;
                }
                &:hover {
                  text-decoration: none;
                }
              }
            }
          }

          li.inactive a {
            pointer-events: none;
            cursor: not-allowed;

            > .fa {
              color: $sidenav-inactive-colour;
            }

            > .nav-link-text {
              color: $sidenav-inactive-colour;
            }
          }
        }

        .navbar-invitation-wrapper {
          width: $sidenav-base-width;
          background: $nav-bg-colour;
          position: absolute;
          left: 0;
          bottom: calc(#{$sidenav-offset-top} - 100vh);
          height: $sidenav-invite-button-height;

          .btn-invite {
            width: 99px;
            height: 98px;
            cursor: pointer;
            border: none;
          }
        }
      }
    }

    .navbar-invitation-wrapper .label {
      color: $nav-item-colour;
      font-size: .7rem;
    }

    .navbar-toggler {
      border-color: transparent;
      color: transparent;
      cursor: pointer;

      &:hover,
      &:focus {
        outline: none !important;
      }

      .icon-bar {
        background-color: $nav-icon-color;
        transition: all 0.6000s;
        width: 30px;
        height: 3px;
        background-image: none;
        display: block;
        margin: 0.4rem 0 0.4rem 0;
      }
    }

    .open {
      .top-bar {
        transform: rotate(45deg);
        transform-origin: 6% 60%;
      }

      .middle-bar {
        opacity: 0;
      }

      .bottom-bar {
        transform: rotate(-45deg);
        transform-origin: 6% 60%;
      }
    }

    .collapsed {
      .top-bar {
        transform: rotate(0);
      }

      .middle-bar {
        opacity: 1;
      }

      .bottom-bar {
        transform: rotate(0);
      }
    }

    .default-switch {
      position: relative;

      span {
        display: inline-block;
        position: relative;
        top: -2px;
        color: $nav-icon-color;
        font-size: 14px;
      }
    }
  }

  .navbar {
    .navbar-nav-top {
      font-size: 0.8rem;
    }
  }
</style>
